import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CdkTableModule } from '@angular/cdk/table';
import { SchoolsDataSource } from './schools.datasource';
import { SchoolsService } from './schools.service';
import { HeaderComponent } from '../shared/header.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditSchoolComponent } from './edit-school.component';
import { SchoolDto } from '@oracychampions/api-interfaces';
import { ConfirmComponent } from '../shared/confirm.modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'oc-schools',
  standalone: true,
  imports: [CommonModule, RouterModule, CdkTableModule, HeaderComponent],
  template: `
    <div class="container-fluid page">
      <oc-header headerTitle="Schools">
        <button class="btn btn-primary btn-rounded" (click)="addSchool()">Add School</button>
      </oc-header>
      <cdk-table #table [dataSource]="dataSource!" class="oc-table">
        <ng-container cdkColumnDef="name">
          <cdk-header-cell *cdkHeaderCellDef class="oc-table-header-cell"> Name </cdk-header-cell>
          <cdk-cell *cdkCellDef="let row" class="oc-table-cell">
            {{ row.name }}
          </cdk-cell>
        </ng-container>

        <ng-container cdkColumnDef="createDate">
          <cdk-header-cell *cdkHeaderCellDef class="oc-table-header-cell"> Created </cdk-header-cell>
          <cdk-cell *cdkCellDef="let row" class="oc-table-cell">
            {{ row.createDate | date }}
          </cdk-cell>
        </ng-container>

        <ng-container cdkColumnDef="actions">
          <cdk-header-cell *cdkHeaderCellDef class="oc-table-header-cell"> &nbsp; </cdk-header-cell>
          <cdk-cell *cdkCellDef="let row" class="oc-table-cell">
            <a (click)="editSchool(row)">Edit</a>&nbsp;<a (click)="deleteSchool(row)">Delete</a>
          </cdk-cell>
        </ng-container>

        <cdk-header-row *cdkHeaderRowDef="displayedColumns" class="oc-table-header-row"></cdk-header-row>
        <cdk-row *cdkRowDef="let row; columns: displayedColumns" class="oc-table-row"></cdk-row>
      </cdk-table>
    </div>
  `,
  styles: `
    
  `,
})
export class SchoolsComponent {
  private schoolsService = inject(SchoolsService);
  private modalService = inject(NgbModal);
  private toastr = inject(ToastrService);

  dataSource: SchoolsDataSource | null = null;
  displayedColumns = ['name', 'createDate', 'actions'];

  constructor() {
    this.dataSource = new SchoolsDataSource(this.schoolsService);
  }

  addSchool() {
    const modalRef = this.modalService.open(EditSchoolComponent, { fullscreen: true });
    modalRef.closed.subscribe(() => {
      this.schoolsService.reloadSchools();
    });
  }

  editSchool(school: SchoolDto) {
    const modalRef = this.modalService.open(EditSchoolComponent, { fullscreen: true });
    modalRef.componentInstance.id = school.id;
    modalRef.componentInstance.model = {
      name: school.name,
    };
    modalRef.closed.subscribe(() => {
      this.schoolsService.reloadSchools();
    });
  }

  deleteSchool(school: SchoolDto) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.closed.subscribe((confirmed) => {
      if (confirmed) {
        this.schoolsService.deleteSchool(school.id).subscribe(() => {
          this.toastr.success('School deleted');
          this.schoolsService.reloadSchools();
        });
      }
    });
  }
}
